export default __webpack_public_path__ + "assets/lightning-bolt.8e2e9719.svg";